import React from "react";
import { Link } from "react-router-dom";

export function Forbidden() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-900 text-white">
      <div className="text-center max-w-md px-6">
        <h1 className="text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-800">
          403
        </h1>

        <h2 className="mt-4 text-3xl font-bold">Access Forbidden</h2>

        <p className="mt-2 text-gray-400">
          You don’t have permission to view this page. Please contact your
          administrator if you believe this is a mistake.
        </p>

        <div className="mt-6">
          <Link
            to="/dashboard/home"
            className="px-6 py-3 rounded-xl font-medium transition-colors duration-300 
              bg-gray-900 text-white shadow-gray-900/10 hover:shadow-gray-900/20
              hover:bg-gradient-to-r hover:from-gray-900 hover:to-gray-800"
          >
            Go Back Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Forbidden;

